import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import { useInstance } from 'intact-vue';
import { breakpoints } from './constants';
import { isStringOrNumber, isNullOrUndefined } from 'intact-shared';
import { baseTypeDefs } from './col';
export function useBreakpoints() {
  var instance = useInstance();
  var breakpointsValue = {};
  breakpoints.forEach(function (breakpoint) {
    instance.on("$receive:" + breakpoint, function (v) {
      if (!v) {
        breakpointsValue[breakpoint] = null;
      } else if (isStringOrNumber(v)) {
        breakpointsValue[breakpoint] = {
          span: Number(v)
        };
      } else {
        breakpointsValue[breakpoint] = v;
      }
    });
  });
  function getBreakpointsClassName(k) {
    var classNameObj = {};
    breakpoints.forEach(function (breakpoint) {
      var value = breakpointsValue[breakpoint];
      if (isNullOrUndefined(value)) return;
      var prefix = breakpoint === 'xs' ? k + "-" : k + "-" + breakpoint + "-";
      if (!isNullOrUndefined(value.span)) {
        classNameObj["" + prefix + value.span] = true;
      }
      _Object$keys(baseTypeDefs).forEach(function (prop) {
        // ignore span prop
        if (prop === 'span') return;
        if (!isNullOrUndefined(value[prop])) {
          classNameObj["" + prefix + prop + "-" + value[prop]] = true;
        }
      });
    });
    return classNameObj;
  }
  return {
    getBreakpointsClassName: getBreakpointsClassName
  };
}